import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { pwaUpdate } from "./update";

export function PwaUpdatePrompt() {
  const { t } = useTranslation();
  const needRefresh = useSyncExternalStore(pwaUpdate.subscribe, pwaUpdate.needRefresh, () => false);
  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-24 z-20 flex items-center gap-3 rounded-lg border border-border bg-popover p-3 text-popover-foreground shadow-lg md:right-4 md:bottom-4 md:left-auto"
    >
      <span className="flex-1 text-sm">{t("pwa.updateAvailable")}</span>
      <button
        type="button"
        className="min-h-11 px-3 text-sm"
        onClick={() => {
          pwaUpdate.dismiss();
        }}
      >
        {t("pwa.dismiss")}
      </button>
      <button
        type="button"
        className="min-h-11 rounded-md bg-primary px-3 text-sm font-medium text-primary-foreground"
        onClick={() => void pwaUpdate.apply()}
      >
        {t("pwa.reload")}
      </button>
    </div>
  );
}
